export enum SubscriptionState {
  ACTIVE = 'active',
  CREATED = 'created',
  TRIALING = 'trialing',
  PENDING = 'pending',
  INCOMPLETE = 'incomplete',
  CANCELLED = 'cancelled',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  EXPIRED = 'expired'
}
